import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorBoundary from "../../../../ErrorBoundary";
import { Select, Tooltip } from "antd";
import isEqual from "react-fast-compare";
import HighCharts from "../../../utils/charts/HighCharts";
import DateAggregation from "../../../layout2/sectionInsight/Widget/WidgetHeader/DateAggregation";
import NoGraphData from "../../../workspace/DisplayChart/NoGraphData";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { getDeepDive } from "../../../../redux/actions/WidgetMaker/WidgetAPI";
import moment from "moment";
import {
  getCombinedDate,
  getCustomizedDate,
  getTimeIntervalDate,
} from "../../../../redux/constants";
const InterestOverTime = ({ widget_id }) => {
  const dispatch = useDispatch();
  const screen = useSelector((state) => state?.Screens?.screen);
  const { Option } = Select;
  const authParams = useSelector((state) => state.Authentication.authParams);
  const deepdive_object = useSelector(
    (state) => state?.WidgetMaker?.deepdive_object
  );
  const twitterTrendsData = useSelector(
    (state) => state?.Screens?.screen?.deep_dive?.twitter_trend
  );
  const trendlineResponse = useSelector(
    (state) =>
      state?.Screens?.screen?.deep_dive?.twitter_trend?.trendlineMentions
  );
  const durationSelectionRef = useRef();
  const [selectedMonthValue, setSelectedMonthValue] = useState(1);
  const headerRef = useRef(null);
  const [refUpdated, setRefUpdated] = useState(false);
  //const [setRefOfSlider, refOfSlider] = useHookWithRefCallback();

  // callback function got called when reference of slider is loaded
  const measuredHeaderRef = useCallback((node) => {
    if (node !== null) {
      headerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);
  // widget container ref
  const widgetContainerRef = useRef(null);
  // callback function got called when reference of widgetContainer is loaded
  const measuredWidgetContainerRef = useCallback((node) => {
    if (node !== null) {
      widgetContainerRef.current = node;
      setRefUpdated(!refUpdated);
    }
  }, []);
  const [widgetContainerStyle, setWidgetContainerStyle] = useState(
    widgetContainerRef?.current
      ? {
          width: "100%",
          height:
            widgetContainerRef?.current?.clientHeight &&
            widgetContainerRef?.current?.clientHeight - 33,
        }
      : null
  );

  const updateSize = () => {
    if (widgetContainerRef?.current) {
      setWidgetContainerStyle({
        width: "100%",
        height:
          widgetContainerRef?.current?.clientHeight &&
          widgetContainerRef?.current?.clientHeight - 33,
      });
    }
  };
  const trendGraphData = useMemo(() => {
    return typeof trendlineResponse === "string"
      ? trendlineResponse
      : trendlineResponse?.data?.line
      ? trendlineResponse?.data?.line?.[0]?.data
      : trendlineResponse?.data?.combination
      ? trendlineResponse?.data?.combination
      : null;
  }, [trendlineResponse]);

  const trendGraphType = useMemo(() => {
    return typeof trendlineResponse === "string"
      ? null
      : trendlineResponse?.data?.line
      ? "line"
      : trendlineResponse?.data?.combination
      ? "combination"
      : null;
  }, [trendlineResponse]);
  useEffect(() => {
    updateSize();
    setRefUpdated(!refUpdated);
  }, [
    headerRef?.current,
    headerRef?.current?.clientHeight,
    headerRef?.current?.offsetHeight,
    widgetContainerRef?.current,
    widgetContainerRef?.current?.clientHeight,
    widgetContainerRef?.current?.offsetHeight,
    trendGraphData,
  ]);

  // console.log(
  //   "trendlineResponse : ",
  //   trendlineResponse,
  //   "widgetContainerStyle : ",
  //   widgetContainerStyle,
  //   "trendGraphData : ",
  //   trendGraphData,
  //   "trendGraphType : ",
  //   trendGraphType,
  //   "deepdive_object : ",
  //   deepdive_object,
  //   "twitterTrendsData : ",
  //   twitterTrendsData
  // );
  const handleDropdownVisibleChange = (value) => {
    if (!value) {
      durationSelectionRef?.current?.blur();
    }
  };
  const handleChangeDuration = (
    value,
    widgetData,
    section_index,
    widget_index
  ) => {
    if (value !== selectedMonthValue) {
      setSelectedMonthValue(value);
      // command center twitter trend deepdive
      let widget_ids = ["twitter-trends_3"];

      let updatedDeepDiveObj = structuredClone(deepdive_object);
      let selectedDuration;
      let durationOfLastMonthForWid = getCustomizedDate(value, "Months");
      selectedDuration = {
        from:
          moment(durationOfLastMonthForWid?.date?.[0]).format("YYYY/MM/DD") +
          " " +
          durationOfLastMonthForWid?.time?.startTime,
        to:
          moment(durationOfLastMonthForWid?.date?.[1]).format("YYYY/MM/DD") +
          " " +
          durationOfLastMonthForWid?.time?.endTime,
      };
      if (updatedDeepDiveObj && selectedDuration) {
        // logic here for default date aggregation value
        let global_date = {
          from: selectedDuration?.from,
          to: selectedDuration?.to,
        };
        let filter_date = [];
        let combinedDate = getCombinedDate(global_date, filter_date);
        let getInterval = getTimeIntervalDate(
          combinedDate?.end_date,
          combinedDate?.start_date,
          updatedDeepDiveObj?.deepdive_on?.data_source,
          updatedDeepDiveObj?.deepdive_on?.x_axis?.attribute
        );
        let updatedDateAgg = getInterval?.defaultVal;

        let finalDatePart = updatedDateAgg === "D" ? null : updatedDateAgg;
        let updatedXaxis = {
          ...deepdive_object?.deepdive_on?.x_axis,
          date_part: finalDatePart,
        };

        updatedDeepDiveObj = {
          ...updatedDeepDiveObj,
          start_date: selectedDuration?.from,
          end_date: selectedDuration?.to,
          deepdive_on: {
            ...updatedDeepDiveObj?.deepdive_on,
            x_axis: {
              ...updatedXaxis,
            },
          },
          screen: screen,
          isDurationModified: true,
        };
        let deep_dive_obj = {};
        let updatedTwitterTrend = {};
        updatedTwitterTrend.trendlineMentions = null;
        updatedTwitterTrend.trendlineMentionsDateAggregation = finalDatePart;
        updatedTwitterTrend.selectedMonthValue = value;
        deep_dive_obj.twitter_trend = updatedTwitterTrend;
        dispatch({
          type: "SET_DEEP_DIVE_DATA_IN_SCREEN_FOR_TWITTER_TREND",
          isDeepDive: true,
          deep_dive: deep_dive_obj,
        });

        dispatch(getDeepDive(authParams, updatedDeepDiveObj, widget_ids));
      }
    }
  };
  return (
    <>
      <div className="portlet border border-color border-radius-4 w-100 h-100">
        <div
          className="portlet__title fontSize-16 p-15 border-bottom border-color font-weight500 d-flex align-items-center justify-content-between"
          ref={measuredHeaderRef}
        >
          {"Interest Over Time"}
          <div className="d-flex align-items-center">
            <Select
              ref={durationSelectionRef}
              popupClassName={
                authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
              }
              showArrow={true}
              onDropdownVisibleChange={handleDropdownVisibleChange}
              placeholder="Select Duration"
              className="ml-2 ticketOverView"
              suffixIcon={
                <img
                  src={
                    authParams?.theme_type === "1" ? accoArrowWhite : accoArrow
                  }
                  className="accordionArrow p-0"
                  alt="accoArrow"
                />
              }
              bordered={false}
              defaultValue={1}
              value={selectedMonthValue}
              onChange={(e) => handleChangeDuration(e)}
              disabled={!trendGraphData}
            >
              <Option value={1} key={"duration_selection_op_1"}>
                Last 1 Month
              </Option>
              <Option value={3} key={"duration_selection_op_2"}>
                Last 3 Months
              </Option>
              <Option value={12} key={"duration_selection_op_3"}>
                Last 12 Months
              </Option>
            </Select>
            <DateAggregation
              // section_index={section_index}
              // widget_index={widget_index}
              // widgetData={widgetData}
              // template_widget={template_widget}
              deepDive={true}
              widget_id={"twitter-trends_3"}
              tabName={deepdive_object?.tabName}
              disabled={!trendGraphData || typeof trendGraphData === "string"}
            />
          </div>
        </div>
        <ErrorBoundary chart={true}>
          {trendGraphData && typeof trendGraphData !== "string" ? (
            <div
              className="portlet__body"
              style={{
                height:
                  "calc(100% - " +
                  (headerRef?.current?.clientHeight
                    ? headerRef?.current?.clientHeight
                    : 0) +
                  "px)",
              }}
              ref={measuredWidgetContainerRef}
            >
              <HighCharts
                id={"InterestOverTime_1"}
                deepDive={true}
                single={trendGraphData}
                xaxis={
                  trendlineResponse?.["x_axis-attribute"]
                    ? trendlineResponse["x_axis-attribute"]
                    : ""
                }
                yaxis={
                  trendlineResponse?.["y-series"]
                    ? trendlineResponse["y-series"]
                    : ""
                }
                style={widgetContainerStyle}
                type={trendGraphType}
                dateAggregationOfThisGraph={
                  twitterTrendsData?.trendlineMentionsDateAggregation
                }
                yAxisMode={trendGraphType === "combination" ? "2" : null}
              />
            </div>
          ) : (
            <div
              className="d-flex align-items-center"
              style={{
                justifyContent: "space-evenly",
                height:
                  "calc(100% - " +
                  (headerRef?.current?.clientHeight
                    ? headerRef?.current?.clientHeight
                    : 0) +
                  "px)",
              }}
              ref={measuredWidgetContainerRef}
            >
              {typeof trendGraphData === "string" ? (
                <div className="portlet__body h-100">
                  <ErrorBoundary>
                    <NoGraphData
                      errorCode="No Data Found"
                      isCommandCenterScreen={true}
                    />
                  </ErrorBoundary>
                </div>
              ) : (
                <div className="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              )}
            </div>
          )}
        </ErrorBoundary>
      </div>
    </>
  );
};

export default React.memo(InterestOverTime, isEqual);
